<app-section-header [title]="'Create Newsletter'" [isBackBtnShown]="true">
  <div class="flex justify-end flex-1">
    <button
      mat-flat-button
      (click)="createNewsletter(allSites.selectedOptions.selected)"
      class="w-1/4 py-3 font-semibold text-white bg-project-2100 disabled:bg-project-3200"
      [disabled]="submitted"
    >
      {{ submitted ? "Creating..." : "Create" }}
    </button>
  </div>
</app-section-header>

<div class="flex flex-wrap items-center justify-center py-3">
  <div class="mb-6 basis-1/2">
    <form [formGroup]="newsletterForm">
      <b class="m-0">Name:</b>
      <mat-form-field
        class="w-full pb-4"
        [floatLabel]="'never'"
        appearance="outline"
      >
        <input matInput formControlName="name" />
        <mat-error
          *ngIf="newsletterForm.controls.name.hasError('required')"
          class="pt-1 text-project-4300"
        >
          Please choose a name
        </mat-error>
      </mat-form-field>

      <b class="m-0">Description:</b>
      <mat-form-field
        class="w-full"
        [floatLabel]="'never'"
        appearance="outline"
      >
        <textarea
          matInput
          formControlName="description"
          matAutosizeMaxRows="5"
        ></textarea>
      </mat-form-field>

      <b class="m-0">Frequency:</b>
      <mat-radio-group
        formControlName="frequency"
        class="flex justify-between w-full py-4"
      >
        <mat-radio-button
          *ngFor="let frequency of availableFrequencies"
          [value]="frequency.key"
        >
          {{ frequency.name }}</mat-radio-button
        >
      </mat-radio-group>
      <mat-error
        *ngIf="
          newsletterForm.controls.frequency.hasError('required') &&
          newsletterForm.controls.frequency.touched
        "
        class="mb-4 text-project-4300"
      >
        Please choose a frequency
      </mat-error>

      <b>Add to site:</b>
      <div class="mb-6">
        <mat-selection-list #allSites class="w-full overflow-auto h-96">
          <mat-list-option
            *ngFor="let sites of availableSites"
            togglePosition="before"
            disableRipple="true"
            [value]="sites"
          >
            <div class="flex items-center justify-between">
              {{ sites.name }}
              <mat-checkbox
                (change)="sites.default = $event.checked"
                (click)="$event.stopPropagation()"
                >Is default</mat-checkbox
              >
            </div>
          </mat-list-option>
        </mat-selection-list>
        <mat-error
          *ngIf="
            newsletterForm.controls.regions.hasError('required') &&
            newsletterForm.controls.regions.touched
          "
          class="pt-1 text-project-4300"
        >
          Please choose a site to add the newsletter on
        </mat-error>
      </div>

      <b class="m-0">Image url:</b>
      <mat-form-field
        class="w-full"
        [floatLabel]="'never'"
        appearance="outline"
      >
        <input matInput formControlName="imageUrl" class="py-2" />
      </mat-form-field>

      <div class="flex justify-between">
        <mat-checkbox formControlName="displayOnce"
          ><b>Is displayed only once</b></mat-checkbox
        >
        <mat-checkbox formControlName="special"><b>Is Special</b></mat-checkbox>
      </div>
    </form>
  </div>
</div>
